import { render, staticRenderFns } from "./invoice-detail.vue?vue&type=template&id=74867b4e&scoped=true"
import script from "./invoice-detail.vue?vue&type=script&lang=js"
export * from "./invoice-detail.vue?vue&type=script&lang=js"
import style0 from "./invoice-detail.vue?vue&type=style&index=0&id=74867b4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74867b4e",
  null
  
)

export default component.exports